import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import useCreateParliamentLiveFilters from 'components/Dashboard/ParliamentLive/useCreateParliamentLiveFilters';
import { store } from 'components/Store';
import dayjs from 'dayjs';
import { useContext } from 'react';
import getAppSite from 'utils/getAppSite';
import { REALTIME_EVENT_SOURCES } from 'utils/realtimeEventSource';

const useGetRealTimeEvents = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const { generalApiCall } = useGeneralApiCall();
  const { createUKDate } = useCreateParliamentLiveFilters();

  const getRealTimeEvents = async ({ source, needsAuthentication = true }) => {
    try {
      if (getAppSite() !== 'usa') {
        const currentUKDate = createUKDate({});
        const sources = REALTIME_EVENT_SOURCES.map(({ value }) => `&source=${value}`).join('');
        const pathname = `/api/realtimeevent/realtime-events?isoDate=${dayjs(currentUKDate)?.format('YYYY-MM-DD')}${sources}`;
        const result = await generalApiCall({
          pathname,
          method: 'get',
          needsAuthentication,
          notShowErrorMessage: true,
          requestSource: source,
        });
        if (!!result) {
          dispatch({ type: 'MODIFY_SECTION', parameter: 'realtimeEvents', value: result });
          return result;
        }
      }
    } catch (error) {}
  };

  const getRealTimeEvent = async ({ source, eventId }) => {
    if (!!eventId) {
      try {
        const pathname = `/api/realtimeevent/realtime-event?id=${eventId}`;
        return await generalApiCall({
          pathname,
          method: 'get',
          needsAuthentication: true,
          notShowErrorMessage: true,
          requestSource: source,
        });
      } catch (error) {}
    }
  };

  return { getRealTimeEvents, getRealTimeEvent };
};

export default useGetRealTimeEvents;
